import type { ToolTabsProps } from './types';

export const ToolTabs = ({ currentTool, onToolChange }: ToolTabsProps) => {
  const base =
    'flex-1 py-2 text-[13px] font-semibold cursor-pointer border transition-colors';
  const active = 'bg-[#161b22] text-[#58a6ff] border-[#58a6ff]';
  const inactive =
    'bg-[#21262d] text-[#8b949e] border-[#30363d] hover:text-[#c9d1d9]';

  return (
    <div className="flex gap-0 mb-4">
      <button
        className={`${base} rounded-l-md ${currentTool === 'floorplans' ? active : inactive}`}
        onClick={() => onToolChange('floorplans')}
      >
        Floor Plans
      </button>
      <button
        className={`${base} ${currentTool === 'diagrams' ? active : inactive}`}
        onClick={() => onToolChange('diagrams')}
      >
        Distribution Board Diagrams
      </button>
      <button
        className={`${base} ${currentTool === 'credits' ? active : inactive}`}
        onClick={() => onToolChange('credits')}
      >
        User Credits
      </button>
      <button
        className={`${base} ${currentTool === 'compression' ? active : inactive}`}
        onClick={() => onToolChange('compression')}
      >
        Compression Test
      </button>
      <button
        className={`${base} rounded-r-md ${currentTool === 'sendemail' ? active : inactive}`}
        onClick={() => onToolChange('sendemail')}
      >
        Send Email
      </button>
    </div>
  );
};
